export default "__VITE_ASSET__dbb377f5__"